module.exports = __webpack_public_path__ + "static/media/editorial-mob.b3da3aa7.png";